import { Typography } from "@mui/material";
import React from "react";

const Condition = () => {
  return (
    <div style={styles.div}>
      <Typography variant="h2">Conditions générales d'utilisation</Typography>
      <p>Date d'entrée en vigueur : 17/07/2023</p>
      <h3>1 - Objet</h3>
      <p>
        L'application "GEO FLAG" (ci-après : l'"Application") propose à ses
        utilisateurs (ci-après : les "Utilisateurs") des parcours, de marche, de
        vélo, de fauteuil roulant et/ou d'entraînement physique (ci-après
        ensemble : les "Parcours") dans des villes ou des destinations
        spécifiques du monde entier. Les présentes conditions générales ont pour
        objet de définir les modalités d'utilisation des services proposés sur
        l'Application (ci-après : les " Services ") ainsi que de définir les
        droits et obligations des parties dans son cadre.
      </p>
      <h3>2. Opérateur d'application et de services, contactez</h3>
      <p>
        L'Application et les Services sont exploités par NORMIT, société par
        actions simplifiée unipersonnelle, immatriculée au RCS de Caen sous le
        n° 949063978, peut être contacté aux coordonnées suivantes :
      </p>
      <ul>
        <li>Adress éléctronique : normit.pro@gmail.com</li>
      </ul>
      <h3>3. Accès à l'application et aux services</h3>
      <h4>3.1 Capacité juridique</h4>
      <p>L'application et les services sont accessibles :</p>
      <ul>
        <li>
          Toute personne ayant la pleine capacité juridique de s'engager dans le
          cadre des présentes conditions générales. Les personnes n'ayant pas la
          pleine capacité juridique ne peuvent accéder à l'Application et aux
          Services qu'avec l'accord de leur représentant légal.
        </li>
        <li>
          A toute personne morale agissant par l'intermédiaire d'une personne
          physique ayant la capacité juridique de contracter au nom et pour le
          compte de la personne morale.
        </li>
      </ul>
      <h4>3.2. Site et services réservés aux particuliers</h4>
      <p>
        Sauf accord exprès et préalable de NORMIT, l'Application et les Services
        sont destinés exclusivement aux particuliers et ne sont pas destinés à
        un usage professionnel, entendu comme toute utilisation directement ou
        indirectement liée à une activité rémunérée exercée de manière non
        occasionnelle dans tous les secteurs de l'industrie et du commerce.
      </p>
      <h3>4. Acceptation des conditions générales</h3>
      <h4>4.1.</h4>
      <p>
        Comme stipulé sur la page de connexion de l'application, l'acceptation
        des présentes conditions générales par les Utilisateurs qui s'inscrivent
        est matérialisée par un clic sur un des modes de connexion à
        l'Application. En ce qui concerne les Utilisateurs qui ne sont pas
        inscrits sur l'Application, leur utilisation de celle-ci et/ou des
        Services implique leur acceptation des présentes conditions générales,
        sans restriction ni réserve.
      </p>
      <h4>4.2.</h4>
      <p>
        L'acceptation des présentes conditions générales ne peut être que
        totale. Toute adhésion sous réserve est considérée comme nulle et non
        avenue. L'Utilisateur qui n'accepte pas d'être lié par les présentes
        conditions générales ne doit pas accéder à l'Application ni utiliser les
        Services.
      </p>
      <h3>5. Enregistrement de la demande</h3>
      <h4>5.1.</h4>
      <p>
        L'utilisation des Services ne nécessite pas l'inscription de
        l'Utilisateur sur l'Application. L'Utilisateur peut s'inscrire sur
        l'Application en remplissant le formulaire prévu à cet effet.
        L'Utilisateur doit fournir l'ensemble des informations marquées comme
        obligatoires. Toute inscription incomplète ne sera pas validée.
        L'inscription entraîne l'ouverture automatique d'un compte au nom de
        l'Utilisateur (ci-après : le " Compte "), lui donnant accès à un espace
        personnel (ci-après : l'" Espace Personnel ") qui permet à l'Utilisateur
        de gérer l'utilisation des Services sous une forme et selon les moyens
        techniques que NORMIT juge les plus appropriés pour rendre lesdits
        Services. L'Utilisateur garantit que toutes les informations fournies
        dans le formulaire d'inscription sont correctes, à jour et sincères et
        ne sont entachées d'aucun caractère trompeur. L'Utilisateur s'engage à
        mettre à jour ses informations dans l'Espace Personnel en cas de
        modifications, afin qu'elles correspondent toujours aux critères
        susmentionnés. L'Utilisateur est informé et accepte que les informations
        saisies aux fins de création ou de mise à jour du Compte valent preuve
        de son identité. Les informations saisies par l'Utilisateur l'engagent
        dès leur validation.
      </p>
      <h4>5.2.</h4>
      <p>
        L'Utilisateur peut accéder à son Espace personnel à tout moment après
        s'être connecté à l'aide de l'identifiant et du mot de passe personnels.
        L'Utilisateur s'engage à utiliser personnellement les Services et à ne
        permettre à aucun tiers de les utiliser à sa place ou pour son compte,
        sauf à en assumer l'entière responsabilité. Il est également responsable
        du maintien de la confidentialité de son identifiant et de son mot de
        passe, tout accès à l'Application en les utilisant étant réputé effectué
        par l'Utilisateur. Ce dernier doit immédiatement contacter NORMIT aux
        coordonnées mentionnées à l'article " Exploitant de l'Application et des
        Services, contact " des présentes s'il constate que son Compte a été
        utilisé à son insu. il reconnaît à NORMIT le droit de prendre toutes les
        mesures appropriées dans un tel cas.
      </p>
      <h4>6. Description des services</h4>
      <p>
        L'Utilisateur a accès aux Services suivants, sous une forme et selon les
        fonctionnalités et moyens techniques que NORMIT juge les plus appropriés
      </p>
      <h4>6.1. Parcours </h4>
      <p>
        L'Utilisateur bénéficie de l'accès aux Parcours parmi ceux proposés sur
        l'Application. L'Utilisateur peut créer ses propres parcours et les
        partager avec d'autres utilisateurs si il est abonné à l'offre premium.
      </p>
      <h4>6.2. Autres services</h4>
      <p>
        NORMIT se réserve le droit d'offrir tout autre Service qu'elle juge
        utile, sous une forme et selon les fonctionnalités et moyens techniques
        qu'elle juge les plus appropriés pour rendre lesdits Services.
      </p>
      <h3>7. Coût des services </h3>
      <p>
        Afin d'accéder aux caractéristiques et fonctionnalités marquées comme
        Premium (“Couronne dorée"), les utilisateurs doivent payer des frais
        d'abonnement. Les frais d'abonnement, ainsi que les taxes associées,
        doivent être payés à l'avance sur une base mensuelle ou annuelle. NORMIT
        se réserve le droit d'augmenter les frais d'abonnement ou d'instituer de
        nouveaux frais à tout moment moyennant un préavis raisonnable.
      </p>
      <h4>7.1 Renouvellement</h4>
      <p>
        Les frais d'abonnement seront facturés automatiquement au début de la
        période. Ces frais seront renouvelés automatiquement jusqu'à ce que
        votre abonnement soit annulé ou résilié. Vos frais d'abonnement seront
        les mêmes que vos frais initiaux, sauf si vous en êtes informé à
        l'avance.
      </p>
      <h4>7.2 Annulation ou résiliation</h4>
      <p>
        Vous pouvez annuler votre abonnement à tout moment en utilisant le
        processus d'abonnement de l'App Store ou du Google Play Store dans votre
        profil iOS ou Android. L'annulation d'un abonnement prendra effet à la
        fin de votre cycle de facturation actuel. À la fin de votre abonnement,
        votre compte redeviendra un abonnement gratuit. Vous pouvez renouveler
        votre abonnement à tout moment sans ouvrir un nouveau compte, bien que
        les frais d'abonnement aient pu augmenter. Vous pouvez supprimer votre
        compte à tout moment.
      </p>
      <h4>7.3 Méthodes de paiement</h4>
      <p>
        Les abonnements peuvent être payés directement via l'App Store ou le
        Google Play Store. Si vous avez payé par le biais de l'App Store ou du
        Google Play Store, vous pouvez modifier votre mode de paiement par le
        biais du compte du magasin correspondant. Aucun remboursement ou crédit
        ne sera accordé par NORMIT, en dehors de ce qui est prévu dans les
        présentes Conditions. Si votre magasin détermine qu'il y a des charges
        frauduleuses sur votre compte résultant de l'utilisation de votre Mode
        de paiement aux Services, vous serez remboursé directement par le
        magasin.
      </p>

      <h3>8. Accord sur les preuves </h3>

      <p>
        L'utilisateur reconnaît et accepte expressément : (i) que les données
        collectées sur l'Application NORMIT et les équipements informatiques
        constituent la preuve de la réalité des opérations effectuées dans le
        cadre des présentes, (ii) que ses données constituent le principal mode
        de preuve accepté entre les parties, notamment pour le calcul des sommes
        dues à NORMIT.
      </p>

      <h3>9. Obligations de l'utilisateur</h3>
      <p>
        Sans préjudice des autres obligations prévues par les présentes,
        l'Utilisateur s'engage à respecter les obligations suivantes.
      </p>
      <h4>9.1.</h4>
      <p>
        L'Utilisateur s'engage, dans son utilisation des Services, à respecter
        les lois et règlements en vigueur, notamment le Code de la route, et à
        ne pas porter atteinte aux droits des tiers ou à l'ordre public. Il est
        seul responsable du bon accomplissement de toutes les formalités,
        notamment administratives, fiscales et/ou sociales et du paiement des
        cotisations, impôts ou taxes de toute nature qui lui incombent, le cas
        échéant dans le cadre de son utilisation des Services. NORMIT ne peut en
        aucun cas être tenu responsable.
      </p>

      <h4>9.2.</h4>
      <p>
        L'Utilisateur reconnaît avoir pris connaissance sur l'Application des
        caractéristiques et contraintes, notamment techniques, de l'ensemble des
        Services. il est seul responsable de son utilisation des Services.
      </p>

      <h4>9.3. L'Utilisateur s'engage également à :</h4>
      <ul>
        <li>
          utiliser l'Application avec prudence et discernement. L'Utilisateur
          est seul responsable de sa sécurité lorsqu'il suit un Parcours. Il est
          recommandé de toujours emprunter les trottoirs ou les zones
          accessibles aux piétons et non les rues ou routes empruntées par les
          véhicules motorisés, même lorsque l'Application indique d'emprunter un
          tel itinéraire ;
        </li>
        <li>
          de ne pas se mettre en danger ou mettre en danger les autres, et
          d'être conscient des différents risques liés à la circulation des
          piétons dans les zones urbaines
        </li>
        <li>
          assurez-vous d'avoir une capacité physique suffisante pour effectuer
          le parcours choisi.
        </li>
      </ul>

      <h4>9.4.</h4>
      <p>
        L'Utilisateur s'engage à faire un usage strictement personnel des
        Services. Il s'interdit donc de céder, concéder ou transférer à
        quiconque, de quelque manière que ce soit, tout ou partie de ses droits
        ou obligations au titre des présentes. L'Utilisateur reconnaît qu'en
        raison notamment d'événements imprévisibles et extérieurs à NORMIT
        (notamment accidents de la route, travaux, conditions météorologiques,
        dégradations, etc.), les informations et données contenues dans
        l'Application peuvent s'avérer inexactes ou obsolètes et que les
        conditions d'accessibilité des Parcours et exercices peuvent être
        modifiées du fait desdits événements. NORMIT ne garantit en aucun cas la
        protection de l'Utilisateur contre tous les dangers liés à
        l'environnement urbain. NORMIT ne peut en aucun cas être tenu pour
        responsable en cas d'accident sur les Parcours proposés.
      </p>

      <h4>9.5.</h4>
      <p>
        Les informations relatives au temps restant sur le Parcours et à la
        vitesse de la course ne peuvent être calculées avec précision car elles
        dépendent nécessairement du comportement de l'Utilisateur. Compte tenu
        de ces contraintes, l'Utilisateur reconnaît que les données et
        informations fournies par NORMIT dans le cadre de l'Application le sont
        à titre indicatif et accepte que la responsabilité de NORMIT ne puisse
        être engagée en raison de l'inexactitude ou de l'imprécision de
        certaines données ou informations.
      </p>

      <h4>9.6.</h4>

      <p>
        L'Application est un outil d'orientation mais ne peut en aucun cas se
        substituer au jugement de l'Utilisateur qui, en fonction du contexte
        réel, doit apprécier lui-même l'opportunité de ne pas suivre les
        recommandations, le Parcours ou les exercices proposés par l'Application
        et/ou le matériel recommandé. NORMIT n'a aucun contrôle sur le
        comportement de l'Utilisateur et ne peut donc être tenu pour responsable
        de son fait.
      </p>

      <h4>9.7.</h4>
      <p>
        9.7. L'Utilisateur déclare comprendre les limites liées au système GPS.
        Les transmissions et les réceptions peuvent être limitées par :
      </p>
      <ul>
        <li>
          Le fonctionnement des systèmes satellitaires et des stations
          terrestres ;
        </li>
        <li>Fonctionnement du smartphone de l'utilisateur ;</li>
        <li>
          Conditions météorologiques et atmosphériques, interférences
          environnementales et magnétiques ;
        </li>
        <li>La qualité du smartphone et/ou de sa fonctionnalité GPS.</li>
        <li>
          L'Utilisateur reconnaît que le signal GPS est précis à 10 (dix) mètres
          près et qu'il lui appartient d'évaluer les conséquences et les risques
          éventuels de sa contrainte technique.
        </li>
      </ul>

      <h4>9.8.</h4>
      <p>
        L'Utilisateur s'engage à fournir à NORMIT toutes les informations
        nécessaires à la bonne exécution des Services. Plus généralement,
        l'Utilisateur s'engage à coopérer activement avec NORMIT en vue de la
        bonne exécution des présentes conditions.
      </p>

      <h4>9.9.</h4>
      <p>
        L'Utilisateur est seul responsable des contenus de toute nature
        (rédactionnels, graphiques, audio, audiovisuels ou autres, y compris le
        nom choisi par l'Utilisateur pour l'identifier sur l'Application) qu'il
        diffuse dans le cadre des Services (ci-après dénommés " Contenus "). Il
        garantit à NORMIT qu'il dispose de tous les droits et autorisations
        nécessaires à la diffusion de son Contenu. Il s'engage à ce que lesdits
        Contenus soient licites, ne portent pas atteinte à l'ordre public, aux
        bonnes mœurs ou aux droits des tiers, n'enfreignent aucune disposition
        législative ou réglementaire et plus généralement, ne soient en aucun
        cas susceptibles de mettre en cause la responsabilité civile ou pénale
        de NORMIT. L'Utilisateur s'interdit donc de diffuser, notamment et sans
        que sa liste soit exhaustive : Contenu à caractère pornographique,
        obscène, indécent, offensant ou inadapté à un public familial,
        diffamatoire, injurieux, violent, raciste, xénophobe ou révisionniste,
        Contenu contrefait, Contenu portant atteinte à l'image d'un tiers,
        mensonger, trompeur ou proposant ou promouvant des activités illégales,
        frauduleuses ou trompeuses, Contenu nuisible aux systèmes informatiques
        de tiers (tels que virus, vers, chevaux de Troie, etc.), et plus
        généralement les contenus susceptibles de porter atteinte aux droits des
        tiers ou de leur porter préjudice, de quelque manière et sous quelque
        forme que ce soit.
      </p>

      <h4>9.10.</h4>
      <p>
        L'Utilisateur est informé et accepte que la mise en œuvre des Services
        nécessite qu'il soit connecté à internet et que la qualité des Services
        dépende directement de sa connexion, dont il est seul responsable.
      </p>

      <h3>10. Garantie de l'utilisateur </h3>
      <p>
        L'Utilisateur garantit NORMIT contre toutes plaintes, réclamations,
        actions et/ou tous recours que NORMIT pourrait subir du fait de la
        violation par l'Utilisateur de l'une quelconque de ses obligations ou
        garanties au titre des présentes conditions générales. Il s'engage à
        indemniser NORMIT pour tout dommage qu'elle subirait et à lui payer tous
        les frais, charges et/ou condamnations qu'elle pourrait avoir à
        supporter de ce fait.
      </p>

      <h3>11. Comportements interdits </h3>
      <h4>11.1.</h4>
      <p>
        Il est strictement interdit d'utiliser les services aux fins suivantes :
      </p>
      <ul>
        <li>
          l'exercice d'activités illégales, frauduleuses ou portant atteinte aux
          droits ou à la sécurité des personnes,
        </li>
        <li>
          atteinte à l'ordre public ou violation des lois et règlements
          applicables,
        </li>
        <li>
          l'intrusion dans un système informatique ou toute activité susceptible
          d'endommager, de contrôler, d'interférer ou d'intercepter tout ou
          partie d'un système informatique, de violer son intégrité ou sa
          sécurité,
        </li>
        <li>
          l'envoi de courriers électroniques non sollicités et/ou la prospection
          ou la sollicitation commerciale,
        </li>
        <li>
          et plus généralement toute pratique détournant les Services à des fins
          autres que celles pour lesquelles ils ont été conçus.
        </li>
      </ul>

      <h4>11.2.</h4>
      <p>
        Il est strictement interdit aux Utilisateurs de copier et/ou détourner à
        leurs fins ou à celles du concept, les technologies, tout ou partie des
        données ou tout autre élément de l'Application NORMIT.
      </p>

      <h4>11.3</h4>
      <p>
        Les éléments suivants sont également strictement interdits : (i) tout
        comportement susceptible d'interrompre, de suspendre, de ralentir ou
        d'empêcher la continuité des Services, (ii) toute intrusion ou tentative
        d'intrusion dans les systèmes de NORMIT, (iii) tout détournement des
        ressources du système de l'Application, (iv) toute action susceptible
        d'imposer une charge disproportionnée sur l'infrastructure de cette
        dernière, (v) toute atteinte aux mesures de sécurité et
        d'authentification, (vi) tout acte susceptible de porter atteinte aux
        intérêts financiers, commerciaux ou moraux de NORMIT ou des utilisateurs
        de son Application, et enfin plus généralement (vii) toute violation des
        présentes conditions générales.
      </p>

      <h3>12. Sanctions des manquements </h3>
      <p>
        En cas de violation de l'une quelconque des dispositions des présentes
        conditions générales ou plus généralement, de violation des lois et
        règlements en vigueur par un Utilisateur, NORMIT se réserve le droit de
        prendre toute mesure appropriée et notamment de : (i) suspendre ou
        supprimer l'accès aux services de l'utilisateur, auteur de l'infraction
        ou du délit, ou y ayant participé, (ii) supprimer tout contenu publié
        sur l'Application, (iii) publier sur l'Application tout message
        d'information que NORMIT juge utile, (iv) notifier toute autorité
        compétente, (v) d'engager toute action en justice.
      </p>

      <h3>13. Responsabilité et garantie de NORMIT</h3>
      <h4>13.1.</h4>
      <p>
        NORMIT s'engage à fournir les Services avec diligence et selon les
        règles de l'art, étant précisé qu'il pèse sur elle une obligation de
        moyens, à l'exclusion de toute obligation de résultat, que les
        Utilisateurs reconnaissent et acceptent expressément.
      </p>

      <h4>13.2</h4>
      <p>
        NORMIT n'a pas connaissance des Contenus mis en ligne par les
        Utilisateurs dans le cadre des Services, sur lesquels elle n'opère
        aucune modération, sélection, vérification ou contrôle d'aucune sorte et
        dans lesquels elle n'intervient qu'en tant qu'hébergeur. En conséquence,
        NORMIT ne peut être tenu responsable des Contenus dont les auteurs sont,
        toute plainte éventuelle doit être adressée en priorité à l'auteur du
        Contenu en question. Les contenus préjudiciables à une personne peuvent
        être notifiés à NORMIT selon les modalités prévues par l'article 6 I 5
        de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie
        numérique, NORMIT se réserve le droit de prendre les mesures décrites à
        l'article "Sanctions des manquements".
      </p>

      <h4>13.3</h4>
      <p>
        NORMIT décline toute responsabilité en cas de perte éventuelle des
        informations accessibles dans l'Espace personnel de l'Utilisateur, ce
        dernier devant en sauvegarder une copie et ne pouvant prétendre à aucune
        indemnisation à son égard.
      </p>

      <h4>13.4</h4>
      <p>
        13.4. NORMIT s'engage à effectuer des contrôles réguliers pour vérifier
        le fonctionnement et l'accessibilité de l'Application. A ce titre,
        NORMIT se réserve le droit d'interrompre temporairement l'accès à
        l'Application pour des raisons de maintenance. NORMIT ne peut être tenue
        responsable des difficultés ou impossibilités temporaires d'accès à
        l'Application qui auraient pour origine des circonstances qui lui sont
        extérieures, la force majeure, ou qui seraient dues à des perturbations
        des réseaux de télécommunications.
      </p>

      <h4>13.5</h4>
      <p>
        NORMIT ne garantit pas aux Utilisateurs (i) que les Services, faisant
        l'objet de recherches constantes pour en améliorer les performances et
        les progrès notamment, seront totalement exempts d'erreurs, de vices ou
        de défauts, (ii) que les Services, étant standards et non proposés à la
        seule intention d'un Utilisateur donné en fonction de ses contraintes
        personnelles, répondront spécifiquement à ses besoins et attentes.
      </p>

      <h3>14. Propriété intellectuelle</h3>
      <p>
        Les systèmes, logiciels, structures, infrastructures, bases de données
        et contenus de toute nature (textes, images, visuels, musiques, logos,
        marques, base de données, etc.) exploités par NORMIT au sein de
        l'Application sont protégés par tous droits de propriété intellectuelle
        ou droits des producteurs de bases de données en vigueur. Tous
        désassemblages, décompilations, décryptages, extractions,
        réutilisations, copies et plus généralement, tous actes de reproduction,
        représentation, diffusion et utilisation de l'un quelconque de ces
        éléments, en tout ou partie, sans l'autorisation de NORMIT sont
        strictement interdits et pourront faire l'objet de poursuites
        judiciaires.
      </p>

      <h3>15. Données personnelles</h3>
      <p>
        NORMIT dispose d'une politique de protection des données personnelles,
        disponible en bas de cette page, et dont l'Utilisateur est expressément
        invité à prendre connaissance.
      </p>

      <h3>16. Confidentialité</h3>

      <p>
        Chaque partie s'engage à garder strictement confidentiels les documents,
        éléments, données et informations de l'autre partie auxquels elle
        s'adresse, qui seront expressément identifiés par l'autre partie comme
        étant confidentiels. S'agissant de NORMIT, les parties conviennent
        d'ores et déjà expressément que son obligation de confidentialité couvre
        les données personnelles que NORMIT sera amené à traiter pour
        l'Utilisateur dans le cadre des Services. L'ensemble de ses informations
        est désigné ci-après comme " Informations confidentielles ". La partie
        destinataire des Informations Confidentielles s'engage à ne pas les
        divulguer sans l'accord préalable de l'autre partie, pendant une période
        de cinq (5) ans à compter de la fin de l'exécution des Services
        concernés. Elle ne peut les transmettre qu'à des employés,
        collaborateurs, stagiaires ou conseillers si ceux-ci sont tenus à la
        même obligation de confidentialité que celle prévue aux présentes. Son
        obligation ne s'étend pas aux documents, éléments, données et
        informations : (i) dont la partie qui les reçoit avait déjà connaissance
        ; (ii) déjà publiques au moment de leur communication ou qui le
        deviendraient sans violation des présentes conditions générales ; (iii)
        qui ont été légalement reçues d'une personne ; (iv) dont la
        communication serait requise par les autorités judiciaires, en
        application des lois et règlements ou en vue d'établir les droits d'une
        partie dans le cadre des présentes conditions générales.
      </p>

      <h3>17. Publicité</h3>

      <p>
        NORMIT se réserve le droit d'insérer sur toute page de l'Application et
        dans toute communication aux Utilisateurs des messages publicitaires ou
        promotionnels sous une forme et dans des conditions dont NORMIT sera
        seul juge.
      </p>

      <h3>18. Liens et site tiers</h3>
      <p>
        NORMIT ne peut en aucun cas être tenue responsable de la disponibilité
        technique des sites internet ou des applications mobiles exploités par
        des tiers (y compris ses partenaires potentiels) auxquels l'Utilisateur
        accéderait via l'Application. NORMIT n'assume aucune responsabilité
        quant au contenu, à la publicité, aux produits et/ou aux services
        disponibles sur ces sites et applications mobiles, dont il est rappelé
        qu'ils sont régis par leurs propres conditions d'utilisation. NORMTI
        n'est pas non plus responsable des transactions entre l'Utilisateur et
        tout annonceur, professionnel ou commerçant (y compris tout partenaire)
        vers lequel l'Utilisateur est orienté par l'Application et ne peut en
        aucun cas être partie à un éventuel litige quelconque avec ces derniers
        concernant notamment la livraison de produits et/ou services, les
        garanties, déclarations et toutes autres obligations auxquelles ces
        derniers sont tenus.
      </p>

      <h3>19. Références commerciales</h3>
      <p>
        L'Utilisateur autorise expressément NORMIT à le citer et à utiliser, le
        cas échéant, la reproduction de sa marque ou de son logo à titre de
        références commerciales, notamment lors de manifestations ou
        d'événements, dans ses documents commerciaux et sur son site internet,
        sous quelque forme que ce soit.
      </p>

      <h3>20. Modifications</h3>

      <p>
        NORMIT se réserve le droit de modifier à tout moment les présentes
        conditions générales. L'Utilisateur sera informé de ces modifications
        par tout moyen utile. L'Utilisateur qui n'accepte pas les conditions
        générales modifiées doit se désinscrire des Services selon les modalités
        prévues à l'article " Durée des Services, désinscription ". Tout
        Utilisateur qui utilise les Services après l'entrée en vigueur des
        conditions générales modifiées est réputé avoir accepté ces
        modifications.
      </p>

      <h3>21. Langue</h3>
      <p>
        En cas de traduction des présentes conditions générales en une ou
        plusieurs langues, la langue d'interprétation sera la langue française
        en cas de contradiction ou de contestation sur le sens d'un terme ou
        d'une disposition.
      </p>

      <h3>22. Droit applicable et juridiction</h3>
      <p>
        Les présentes conditions générales sont régies par le droit français. En
        cas de litige sur la validité, l'interprétation et/ou l'exécution des
        présentes conditions générales, les parties conviennent que les
        tribunaux de Paris seront exclusivement compétents pour juger, sauf
        règles de procédure impératives.
      </p>
    </div>
  );
};

export default Condition;

const styles = {
  div: {
    marginLeft: 5,
  },
};
